/**
 * Модель правового документа (`docs/features/2026-08-26_legal-documents`).
 *
 * Тексты живут в коде, а не в базе: они меняются раз в год и правятся через MR,
 * где их видно в ревью. Структура намеренно бедная — абзац, список, таблица:
 * богатый формат породил бы редактор, а редактор — подсистему, которой у фичи
 * нет (полный эпик — CTHS-164).
 */

/** Блок внутри раздела. */
export type LegalBlock =
    | {kind: 'p'; text: string}
    | {kind: 'list'; items: string[]}
    | {kind: 'table'; head: string[]; rows: string[][]};

export interface LegalSection {
    /** Якорь для оглавления; попадает в адрес страницы. */
    id: string;
    title: string;
    blocks: LegalBlock[];
}

export interface LegalDocument {
    /** Код типа — совпадает с `LegalDocumentType` на бэкенде. */
    type: 'USER_AGREEMENT' | 'PRIVACY_POLICY' | 'PERSONAL_DATA_POLICY';
    title: string;
    /** Короткое имя для ссылок в футере, где длинное название не помещается. */
    shortTitle: string;
    /** Версия. Должна совпадать с реестром бэкенда — сверяется тестом. */
    version: string;
    /** Дата вступления в силу в формате ISO. */
    effectiveOn: string;
    /** Часть пути после `/legal/`. */
    slug: string;
    /** Вводный абзац перед оглавлением. */
    intro: string;
    sections: LegalSection[];
}

/**
 * Реквизиты оператора персональных данных. Вынесены в константы, а не вписаны
 * в каждый документ: реквизиты меняются целиком и сразу во всех трёх текстах,
 * и расхождение между ними — дефект, который никто не заметит глазами.
 *
 * Значения ниже — намеренная заглушка по решению владельца (requirements.md, §7):
 * реальные реквизиты в репозиторий не кладём, перед публикацией их подставляют
 * через env/конфиг вне репозитория. Это единственная точка подстановки.
 */
export const OPERATOR_NAME = 'Forwolk Network inc.';
export const OPERATOR_POSTAL_ADDRESS = '101000, Россия, Москва, ул. Ленина, 1';

/** Канал обращений субъектов персональных данных. */
export const CONTACT_EMAIL = 'support@forwolk.com';
